import { useState } from "react";
import { Palette, Type, Sparkles, Crown, Wallet, PlayCircle, ShieldCheck, BarChart3 } from "lucide-react";
import { StatsSection } from "./StatsSection";
import { useSettings } from "../../../lib/providers";
import { BrandingSection } from "./BrandingSection";
import { ContentSection } from "./ContentSection";
import { ThemeSection } from "./ThemeSection";
import { PlansSection } from "./PlansSection";
import { PaymentsSection } from "./PaymentsSection";
import { TutorialsSection } from "./TutorialsSection";
import { AccountSection } from "./AccountSection";

const SECTIONS = [
  ["stats", "Stats & Metrics", BarChart3, StatsSection],
  ["branding", "Branding & contact", Palette, BrandingSection],
  ["content", "Page text", Type, ContentSection],
  ["theme", "Theme & colors", Sparkles, ThemeSection],
  ["plans", "Plans & pricing", Crown, PlansSection],
  ["payments", "Payment Accounts & Banks", Wallet, PaymentsSection],
  ["tutorials", "Tutorials", PlayCircle, TutorialsSection],
  ["account", "Admin account", ShieldCheck, AccountSection],
];

export const SettingsPanel = () => {
  const { settings } = useSettings();
  const [sec, setSec] = useState("stats");
  if (!settings) return null;
  const Section = SECTIONS.find((s) => s[0] === sec)[3];
  return (
    <div className="grid gap-6 lg:grid-cols-[230px_1fr]">
      <nav className="lux-card flex h-fit gap-1 overflow-x-auto p-2 lg:sticky lg:top-24 lg:flex-col" data-testid="settings-nav">
        {SECTIONS.map(([k, label, Icon]) => (
          <button key={k} type="button" onClick={() => setSec(k)} data-testid={`settings-nav-${k}`}
            className={`flex shrink-0 items-center gap-3 rounded-xl px-4 py-2.5 text-left text-sm transition-colors ${sec === k ? "font-semibold" : "text-muted-foreground hover:bg-accent"}`}
            style={sec === k ? { background: "var(--gold-soft)", color: "var(--gold)" } : undefined}>
            <Icon className="h-4 w-4" />{label}
          </button>
        ))}
      </nav>
      <div key={sec} className="fade-up"><Section /></div>
    </div>
  );
};
